import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HelpModalModule } from 'NewAngular/features/components/modals/help-modal/help-modal.module';
import { DisabledModule } from 'NewAngular/features/directives/disabled/disabled.module';
import * as i0 from "@angular/core";
export class RadioButtonGroupModule {
}
RadioButtonGroupModule.ɵfac = function RadioButtonGroupModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || RadioButtonGroupModule)(); };
RadioButtonGroupModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: RadioButtonGroupModule });
RadioButtonGroupModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, DisabledModule, FormsModule, HelpModalModule] });
